export default{
    limitInfo:{
        Notification:{
           text:'逾期未支付，每天对逾期金额收取一定比例的滞纳金',
        },
        Message:{
            title:'提示',
            text1:'账期结算单逾期',
            text2:'天收取账期结算金额的',
            text3:'%作为滞纳金',
            buttonText:'确定'
        },
        Alert:{
            error:{
                title:'提示',
                text:'数据请求失败，请重试',
                buttonText:'确定',
            }
        },
        Button:{
            
        },
        Placeholder:{

        },
        Validate:{

        },
        Description:{
            
        },
        Checkbox:{
            
        },
        Table:{
            headerName:['授信商家','账期类型','对账日期','滞纳金比例','最晚还款期限','授信额度','当前可用额度','授信时间','状态'],
            rowScope:{
                text1:'账单生成',
                text2:'天后'
            },
            noData: '暂无数据'
        },
        ValidData:{
            
        },
        InvalidData:{
            
        },
        Confirm:{
            
        }
    }
    
}